// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Ud1L","subheader":"ReorderModal_subheader__MueN-","listWrap":"ReorderModal_listWrap__3jge2"};